var React = require('react');

function ExpertreviewInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"5","y":"17","width":"12","height":"24","rx":"4","fill":"#FF6A3C","stroke":"#FF6A3C","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M17 18.1255C17 17.3894 17.2031 16.6677 17.5869 16.0397L21.0975 10.295C21.935 8.92447 23.5557 8.24362 25.1208 8.6048V8.6048C27.2214 9.08956 28.4755 11.2483 27.856 13.3133L27.816 13.4468C26.9861 16.2131 29.3749 18.8783 32.2152 18.3551L39.4309 17.0259C42.1476 16.5254 44.5418 18.8639 44.1053 21.5917L41.5389 37.632C41.2284 39.5725 39.5543 41 37.5891 41H21C18.7909 41 17 39.2091 17 37V18.1255Z","stroke":"#FF6A3C","strokeWidth":"3","key":1})]);
}

ExpertreviewInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ExpertreviewInline;

ExpertreviewInline.default = ExpertreviewInline;
